import React from 'react';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';

export const SubscriptionsRoutes: BaseRoute[] = [
  // {
  //   path: 'viewing',
  //   title: 'Subscriptions',
  //   name: 'product.landing.menuViewing',
  //   feature: Feature.,
  //   component: React.lazy(() => import('./viewing/viewing')),
  //   hideFromMainMenu: true,
  //   isActive: true,
  // },
  {
    path: '*',
    title: 'Subscriptions',
    name: 'product.subscriptions.tabs.viewing',
    feature: Feature.SubscriptionViewing,
    protected: true,
    hideFromMainMenu: true,
    isActive: true,
    component: React.lazy(() => import('./viewing/viewing')),
    icon: 'icon-box-office_64',
  },
  {
    path: 'inactive',
    title: 'Subscriptions',
    name: 'product.subscriptions.tabs.inactive',
    feature: Feature.SubscriptionInactive,
    component: React.lazy(() => import('./inactive/inactive')),
    hideFromMainMenu: true,
    protected: true,
    icon: 'icon-link-smartcard',
  },
  {
    path: 'pending',
    title: 'Subscriptions',
    name: 'product.subscriptions.tabs.pending',
    feature: Feature.SubscriptionPending,
    component: React.lazy(() => import('./pending/pending')),
    hideFromMainMenu: true,
    protected: true,
    icon: 'icon-change-package',
  },
  {
    path: 'pending-actions',
    title: 'Subscriptions',
    name: 'product.subscriptions.tabs.pending-actions',
    feature: Feature.SubscriptionPending,
    component: React.lazy(() => import('./pending-actions/pending-actions')),
    hideFromMainMenu: true,
    protected: true,
    icon: 'icon-change-package',
  },
];